import React from 'react';
import { Link } from 'react-router-dom';
import './Landing.css';

const Landing: React.FC = () => {
  return (
    <div className="landing">
      <header className="landing-header">
        <div className="wrap landing-nav">
          <span className="landing-brand">
            <img src="/logo192.png" alt="Meerkapp logo" />
            Meerkapp
          </span>
          <Link className="landing-nav-cta" to="/login">Log in</Link>
        </div>
      </header>

      <main>
        {/* Hero */}
        <div className="landing-hero">
          <div className="wrap">
            <h1>Real posts, <span className="accent">right where you are</span></h1>
            <p>
              Meerkapp is a location-based social network. Every post is GPS-verified,
              so you see what's genuinely happening around you — from a trusted local community.
            </p>
            <div className="landing-cta-row">
              <Link className="landing-btn landing-btn-primary" to="/register">Get started</Link>
              <Link className="landing-btn landing-btn-ghost" to="/login">Log in</Link>
            </div>
            <div className="landing-stores">
              <span className="landing-store-badge"><span>🤖</span><span><small>Coming soon on</small>Google Play</span></span>
              <span className="landing-store-badge"><span></span><span><small>Coming soon on</small>App Store</span></span>
            </div>
            <p className="landing-soon">Mobile apps launching soon. Use the web app today.</p>
          </div>
        </div>

        {/* Features */}
        <section id="features">
          <div className="wrap">
            <h2 className="landing-section-title">Built for what's actually around you</h2>
            <p className="landing-section-sub">No bots, no faked check-ins. Meerkapp keeps your feed local, authentic, and trustworthy.</p>
            <div className="landing-grid">
              <div className="landing-feature">
                <div className="ico">📍</div>
                <h3>GPS-verified posts</h3>
                <p>Every post is validated against your real location at the moment you share it, so you can trust that local content is truly local.</p>
              </div>
              <div className="landing-feature">
                <div className="ico">🛡️</div>
                <h3>Trust ratings</h3>
                <p>A community trust score helps surface reliable voices and keeps the platform authentic and safe.</p>
              </div>
              <div className="landing-feature">
                <div className="ico">🗺️</div>
                <h3>Location-based feed</h3>
                <p>Choose your radius — from your immediate neighborhood to city, region, or the whole world — and see what matters near you.</p>
              </div>
              <div className="landing-feature">
                <div className="ico">📰</div>
                <h3>Local news, mixed in</h3>
                <p>Relevant local news is woven into your feed alongside community posts, tuned to your area.</p>
              </div>
              <div className="landing-feature">
                <div className="ico">💬</div>
                <h3>Posts, photos &amp; chat</h3>
                <p>Share text and images, comment, like, follow, and message people directly — everything you expect from a modern social app.</p>
              </div>
              <div className="landing-feature">
                <div className="ico">⚡</div>
                <h3>Real-time updates</h3>
                <p>Comments and messages arrive live, so conversations around you never feel stale.</p>
              </div>
            </div>
          </div>
        </section>

        {/* How it works */}
        <section className="landing-bg2">
          <div className="wrap">
            <h2 className="landing-section-title">Get started in three steps</h2>
            <p className="landing-section-sub">You'll be posting to your neighborhood in under a minute.</p>
            <div className="landing-steps">
              <div className="landing-step">
                <h3>Create your account</h3>
                <p>Sign up in seconds and set up your profile. New members start with a trust rating to build on.</p>
              </div>
              <div className="landing-step">
                <h3>Share your location</h3>
                <p>Allow location access so your posts are verified and your feed is tailored to where you are.</p>
              </div>
              <div className="landing-step">
                <h3>Post &amp; explore</h3>
                <p>Share what's happening, discover nearby posts and news, and connect with your local community.</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA band */}
        <section>
          <div className="wrap">
            <div className="landing-cta-band">
              <h2>Join your neighborhood on Meerkapp</h2>
              <p>Start sharing real, location-verified moments with the people around you.</p>
              <Link className="landing-btn landing-btn-primary" to="/register">Get started free</Link>
            </div>
          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <div className="wrap landing-foot">
          <div>© 2026 Meerkapp Inc. All rights reserved.</div>
          <div className="landing-foot-links">
            <Link to="/login">Log in</Link>
            <a href="/privacy.html">Privacy Policy</a>
            <a href="mailto:adm.meerkapp@gmail.com">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Landing;
